import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-mist" data-id="element-143" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-4 py-5 sm:py-8" data-id="element-144" data-mp="3700p8qnwlp43">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De pasar horas preparando materiales a tener una estructura mucho más clara para organizar las clases." data-id="element-145" data-mp="31zwc9am7fcim" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-146" data-mp="2s2rtlkrkhz6k">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-lg border border-navy/10 bg-white p-3 shadow-sm ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-147" data-mp="v8dite99jy8p" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-148" data-mp="h8awv9l20jp4">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={14} aria-hidden="true" className="fill-energy text-spark" data-id="element-149" data-mp="78k3jb88caqm" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.8rem] leading-snug text-navy sm:text-sm" data-id="element-150" data-mp="c73rtiaapym5">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-2.5" data-id="element-151" data-mp="zysbybcyrgs0">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-electric font-display text-xs font-extrabold text-white" data-id="element-152" data-mp="14uzmyik7vigt">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-153" data-mp="v3d17sa960zt">
                  <p className="font-display text-sm font-extrabold text-navy" data-id="element-154" data-mp="1iv1x1ima97li">{t.author}</p>
                  <p className="text-xs leading-tight text-navy/65" data-id="element-155" data-mp="1nmjwu3ckl24w">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-156" data-mp="1xfmuz963yxus" />
      </div>
    </section>;
}